import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import VeranstaltungArea from '@containers/bsw-veranstaltung/layout-01'
import StartArea from '@containers/bsw-preis-fuer-wirtschaftsjournalismus/layout-03'
import VeranstaltungInfoArea from '@containers/bsw-preis-fuer-wirtschaftsjournalismus/layout-01'
import GewinnerArea from '@containers/bsw-preis-fuer-wirtschaftsjournalismus/layout-02'

const BSWPreisFuerWirtschaftsJournalismusPage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <StartArea
          data={{
            ...content['start-section']
          }}
          dataInfo={{
            ...content['info-section']
          }}
          bg="white"
        />
        <VeranstaltungArea
          data={{
            ...content['veranstaltung-section']
          }}
          bg="white"
        />
        <VeranstaltungInfoArea
          data={{
            ...content['info-section']
          }}
          dataSlider={{
            ...content['slider-section']
          }}
          dataCategory={{
            ...content['category-section']
          }}
          dataJury={{
            ...content['jury-section']
          }}
          bg="white"
        />
        <GewinnerArea
          dataMessage={{
            ...content['message-section']
          }}
          data={{
            ...content['gewinner-section']
          }}
          bg="white"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query BSWPreisFuerWirtschaftsJournalismusPageQuery(
    $title: String
    $locale: String
  ) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default BSWPreisFuerWirtschaftsJournalismusPage
